module.exports = __webpack_public_path__ + "static/media/md-search.ca1a8eca.svg";